import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import Button from 'components/Button'
import FilterDiv from 'components/FilterDiv'
import BatchFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter/Partials/BatchFilter'
import BlacklistFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter/Partials/BlacklistFilter'
import CompletionFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter/Partials/CompletionFilter'
import DegreeAndDepartmentFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter/Partials/DegreeAndDepartmentFilter'
import StatusFilter from 'modules/Students/Partials/StudentsInfoTable/StudentFilter/Partials/StatusFilter'
import { degreeListConvertion } from 'utils/degreeListConversion'

const { TabPane } = StyledTab

const StudentFilter = ({
  cardData,
  setQuery,
  degreeList,
  filterData,
  setFilterData,
  batchValue,
  setBatchValue,
  cardsDetails,
  rangeValue,
  setRangeValue,
  setSelectedStudents,
  currentUrl,
  checkedDegreeData,
  setCheckedDegreeData,
  specializationList,
}) => {
  const [filters, setFilters] = useState({})
  const [statusValue, setStatusValue] = useState([])
  const [backListValue, setBackListValue] = useState([])
  const [degreeFilter, setDegreeFilter] = useState([])
  const [specializationFilter, setSpecializationFilterState] = useState([])
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [degreeListData, setDegreeListData] = useState([])
  const [tapNumber, setTapNumber] = useState(null)
  const [checkedKeys, setCheckedKeys] = useState(checkedDegreeData || []);
  const [completionValues, setCompletionValues] = useState({ minValue: 0, maxValue: 100 })
  // Snapshots of last applied states
  const [appliedStatusValue, setAppliedStatusValue] = useState([])
  const [appliedBackListValue, setAppliedBackListValue] = useState([])
  const [appliedDegreeFilter, setAppliedDegreeFilter] = useState([])
  const [appliedSpecializationFilter, setAppliedSpecializationFilter] = useState([])
  const [appliedCheckedKeys, setAppliedCheckedKeys] = useState(checkedDegreeData || [])
  const [appliedCompletionValues, setAppliedCompletionValues] = useState({ minValue: 0, maxValue: 100 })

  useEffect(() => {
    if (checkedDegreeData && checkedDegreeData.length > 0) {
      setCheckedKeys(checkedDegreeData);
    }
  }, [checkedDegreeData]);

  useEffect(() => {
    const updatedData = degreeListConvertion(degreeList)
    setDegreeListData(updatedData)
    if (tapNumber != cardData) {
      setTapNumber(cardData)
      setFilters({})
      setBatchValue([])
    }
    if (filterData === true || filterData === null) {
      setFilters({})
      setFilterData(false)
    }
  }, [degreeList, cardData, tapNumber, filterData])

  const changeBatchRange = range => {
    if (range?.startBatch != '' && range?.endBatch != '') {
      setFilters(prev => {
        return {
          ...prev,
          startBatch: moment(range.startBatch, 'YYYY').format('x'),
          endBatch: moment(range.endBatch, 'YYYY').add(1, 'years').format('x'),
        }
      })
      setBatchValue([
        moment(range.startBatch, 'x').toDate(),
        moment(range.endBatch, 'x').toDate(),
      ])
    } else {
      let filterCopy = { ...filters }
      delete filterCopy.startBatch
      delete filterCopy.endBatch
      setFilters(filterCopy)
      setBatchValue([])
    }
  }
  const changeBlackList = list => {
    setBackListValue(list)

    let attendanceBacklisted = list.some(val => 'LOW_ATTENDANCE' === val)
    let conductBacklisted = list.some(val => 'BAD_CONDUCT' === val)
    let collegeFeeBacklisted = list.some(val => 'FEES_NOT_PAID' === val)
    setFilters(prev => {
      return {
        ...prev,
        attendanceBacklisted,
        conductBacklisted,
        collegeFeeBacklisted,
      }
    })
  }

  const onStatusChange = status => {
    if (status.length) {
      setStatusValue([status[status.length - 1]])
      setFilters(prev => {
        return { ...prev, status: status[status.length - 1] }
      })
    } else {
      setStatusValue([])
      let filterCopy = { ...filters }
      delete filterCopy.status
      setFilters(filterCopy)
    }
  }
  const onCompletionChange = val => {
    setCompletionValues(val)
    setFilters(prev => {
      return {
        ...prev,
        completionStart: val.minValue,
        completionEnd: val.maxValue,
      }
    })
  }

  const submitFilter = () => {
    // Persist current degree tree selection upward
    setCheckedDegreeData(checkedKeys)

    // Capture snapshots of the applied state
    setAppliedStatusValue(statusValue)
    setAppliedBackListValue(backListValue)
    setAppliedDegreeFilter(degreeFilter)
    setAppliedSpecializationFilter(specializationFilter)
    setAppliedCheckedKeys(checkedKeys)
    setAppliedCompletionValues(completionValues)
    
    // Check if filters object has any meaningful values
    const hasActiveFilters = Object.keys(filters).some(key => {
      const value = filters[key];
      return value !== undefined && value !== null && value !== '' && 
             (Array.isArray(value) ? value.length > 0 : true);
    });
    
    if (hasActiveFilters) {
      let queryParams = ''
      Object.keys(filters)?.forEach(val => {
        const filterValue = filters[val];
        // Only add non-empty values to query
        if (filterValue !== undefined && filterValue !== null && filterValue !== '' &&
            (!Array.isArray(filterValue) || filterValue.length > 0)) {
          queryParams = `${queryParams}${val}=${filterValue}&`
        }
      })
      queryParams = queryParams.substring(0, queryParams?.length - 1)
      
      setQuery(queryParams)
    } else {
      setQuery('')
    }
    
    setIsMenuOpen(false)
    setSelectedStudents([])
  }

  const onDegreeFilterChange = data => {
    if (data && data.length > 0) {
      setDegreeFilter(data)
      setFilters(prev => ({
        ...prev,
        degreeStreamMapIds: data.toString(),
      }))
    } else {
      setDegreeFilter([])
      // Use functional update to avoid race conditions
      setFilters(prev => {
        const filterCopy = { ...prev }
        delete filterCopy.degreeStreamMapIds
        return filterCopy
      })
    }
  }

  const onSpecializationFilterChange = data => {
    if (data && data.length > 0) {
      setSpecializationFilterState(data)
      const specialisationsIds = Array.isArray(data)
        ? data.join(',')
        : data.toString()
      setFilters(prev => ({
        ...prev,
        specialisationsIds,
      }))
    } else {
      setSpecializationFilterState([])
      // Use functional update to avoid race conditions
      setFilters(prev => {
        const filterCopy = { ...prev }
        delete filterCopy.specialisationsIds
        return filterCopy
      })
    }
  }

  const menu = (
    <MenuFlex column>
      <StyledTab tabPosition={'left'} type="card">
        <TabPane tab="Batch" key="1">
          <BatchFilter
            key={cardData}
            cardNumber={cardData}
            setBatchFilter={changeBatchRange}
            submitFilter={submitFilter}
            batchValue={batchValue}
            filterData={filterData}
            rangeValue={rangeValue}
            setRangeValue={setRangeValue}
          />
        </TabPane>
        <TabPane tab="Degree & Department" key="2">
          <DegreeAndDepartmentFilter
            cardNumber={cardData}
            degreeList={degreeListData}
            setDegreeList={onDegreeFilterChange}
            setSpecializationList={onSpecializationFilterChange}
            filterData={filterData}
            currentUrl={currentUrl}
            degreeFilter={degreeFilter}
            checkedDegreeData={checkedDegreeData}
            setCheckedDegreeData={setCheckedDegreeData}
            checkedKeys={checkedKeys}
            setCheckedKeys={setCheckedKeys}
          />
        </TabPane>
        <TabPane tab="Status" key="3">
          <StatusFilter
            cardNumber={cardData}
            setStatusList={onStatusChange}
            value={statusValue}
            filterData={filterData}
            cardsDetails={cardsDetails}
            
          />
        </TabPane>
        <TabPane tab="Blacklist" key="4">
          <BlacklistFilter
            cardNumber={cardData}
            setBlackList={changeBlackList}
            value={backListValue}
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </TabPane>
        <TabPane tab="Completion" key="5">
          <CompletionFilter
            cardNumber={cardData}
            setCompletionChange={onCompletionChange}
            filterData={filterData}
            currentUrl={currentUrl}
          />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            // Revert UI selections to last applied snapshots
            setStatusValue(appliedStatusValue)
            setBackListValue(appliedBackListValue)
            setDegreeFilter(appliedDegreeFilter)
            setSpecializationFilterState(appliedSpecializationFilter)
            setCheckedKeys(appliedCheckedKeys)
            setCompletionValues(appliedCompletionValues)

            // Rebuild internal filters object from snapshots
            const next = {}
            if (appliedStatusValue?.length) {
              next.status = appliedStatusValue[appliedStatusValue.length - 1]
            }
            if (appliedBackListValue?.length) {
              next.attendanceBacklisted = appliedBackListValue.includes('LOW_ATTENDANCE')
              next.conductBacklisted = appliedBackListValue.includes('BAD_CONDUCT')
              next.collegeFeeBacklisted = appliedBackListValue.includes('FEES_NOT_PAID')
            }
            if (appliedDegreeFilter?.length) {
              next.degreeStreamMapIds = appliedDegreeFilter.toString()
            }
            if (appliedSpecializationFilter?.length) {
              next.specialisationsIds = appliedSpecializationFilter.toString()
            }
            if (appliedCompletionValues.minValue !== 0 || appliedCompletionValues.maxValue !== 100) {
              next.completionStart = appliedCompletionValues.minValue
              next.completionEnd = appliedCompletionValues.maxValue
            }
            setFilters(next)

            setIsMenuOpen(false)
          }}
        />
        <Button.Primary onClick={submitFilter} text="Apply Filter" />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <FilterDiv
      overlayMenu={menu}
      open={isMenuOpen}
      setOpen={flag => {
        setIsMenuOpen(flag)
      }}
      DWidth={'600px'}
    />
  )
}

export default StudentFilter